import ApplicationController from './application_controller'
import DateRangePicker from "daterangepicker/daterangepicker"
import moment from "moment"

export default class extends ApplicationController {
    static targets = [];

    connect() {
        super.connect();
        this.mountDatepicker(this.element);
    }

    disconnect() {
        super.disconnect();
        this.daterangepicker.remove();
    }

    mountDatepicker(el) {
        var options = {
            locale: {
                format: "DD/MM/YYYY",
                cancelLabel: 'Clear'
            },
            autoUpdateInput: false,
            autoApply: true,
            singleDatePicker: true
        };

        var data_option = this.data.get('options');
        if( data_option ) {
            var o = JSON.parse(data_option);
            options = Object.assign(options,o)
        }

        if( options.ranges === true ) {
            options = Object.assign(
                options,
                {
                    ranges: {
                        'Today': [moment(), moment()],
                        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'This week': [moment().startOf('week'), moment().endOf('week')],
                        'Last week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                    }
                });
        }

        this.log("options", options);
        this.daterangepicker = new DateRangePicker(el, options);
        $(this.element).on("cancel.daterangepicker", function(ev,picker) {
            $(this.element).val(' ');
        }.bind(this));
        $(this.element).on("apply.daterangepicker", function(ev,picker) {
            this.log("picker",picker);
            if(picker.singleDatePicker) {
                $(this.element).val(picker.startDate.format(picker.locale.format));
            } else {
                $(this.element).val(picker.startDate.format(picker.locale.format) + ' - ' + picker.endDate.format(picker.locale.format));
            }
        }.bind(this));
    }
}
